import { render, staticRenderFns } from "./alipayResultPage.vue?vue&type=template&id=07550a7a&scoped=true"
import script from "./alipayResultPage.vue?vue&type=script&lang=js"
export * from "./alipayResultPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07550a7a",
  null
  
)

export default component.exports